// @flow
import React from 'react';

import { Button } from 'bs';
import { mergeClassNames } from 'utils/functions';

type Props = {
    /** button label */
    label: string,
    /** will be appended to the classes */
    className: string,
};

const CancelButton = ({ label, className, ...domProps }: Props) => (
    <Button flavor='light' className={mergeClassNames('float-right', className)} {...domProps}>
        {label}
    </Button>
);

CancelButton.defaultProps = {
    label: 'Cancel',
    className: '',
};

export default CancelButton;
